module.exports = __webpack_public_path__ + "assets/img/zhuomian.2f951cad.png";